/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { STEP_STATE_ACTIVE, STEP_STATE_DONE } from './chat/generationStepStates';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const CommandIntelligenceStepIcon = ({ state, pendingDotSx }) => {
  if (state === STEP_STATE_DONE) {
    return <CheckCircleOutline sx={{ fontSize: 16, color: 'success.main' }} />;
  }

  if (state === STEP_STATE_ACTIVE) {
    return <CircularProgress size={14} thickness={5} color="primary" />;
  }

  return <Box sx={pendingDotSx} aria-hidden />;
};

CommandIntelligenceStepIcon.propTypes = {
  state: PropTypes.string.isRequired,
  pendingDotSx: PropTypes.object,
};

export default CommandIntelligenceStepIcon;
